import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.filter('formatTijd', function(v) {
  let suffix = ""
  if (v > 24*60) {
    v -= 24*60
    suffix = " n.m."
  }
  let m = (v % 60).toString()
  if (m.length === 1) m = '0' + m
  return Math.floor(v/60).toString() + ":" + m + suffix
})

Vue.filter('formatTijdsduur', function(v) {
  if (v === 0) return "0"
  if (v % 60 === 0) return `${Math.floor(v / 60)} uur`
  if (Math.abs(v) < 60) return `${v} min`
  if (v > 0) return `${Math.floor(v / 60)}u ${v % 60}min`
  v = Math.abs(v)
  return `-${Math.floor(v / 60)}u ${v % 60}min`
})

Vue.filter('weekdag', function(d) {
  return ["zo", "ma", "di", "woe", "do", "vr", "za"][d.getDay()]
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
